<template>
  <b-alert
    v-if="emailControl.status"
    class="mt-1 pt-1"
    variant="primary"
    show
  >
    <div class="alert-body text-center">
      <FeatherIcon icon="InfoIcon" />
      <div class="pb-1">
        Bu email adresi başka bir müşteri kartında kullanılmaktadır.
      </div>
      <div class="pb-1">
        <b-button
          variant="primary"
          :to="'/app/customers/view/' + emailControl.id"
          size="sm"
        >
          Müşteri Kartı Görüntüle
        </b-button>
      </div>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'

export default {
  name: 'EmailAlert',
  components: {
    BAlert, BButton,
  },
  computed: {
    dataItem() {
      return this.$store.getters['customers/dataItem']
    },
    emailControl() {
      return this.$store.getters['customers/emailControl']
    },
  },
}
</script>
